import { lazyRouteComponent } from "@tanstack/react-router";
import { CandlestickChart } from "lucide-react";

import type { PageDef } from "@/app/registry";

import { PERIODS, type Period } from "./chart";
import { INTERVALS, type Interval } from "./intradayData";

export interface StockSearchParams {
  /** Chart period (default 1Y). */
  period?: Period;
  /** Chart overlays: "sma50,sma200,st", or "none". Default SMA 50 and 200. */
  ov?: string;
  /** Bar interval of the 1D chart (default 5m). */
  iv?: Interval;
  /** The tab under the chart (default fundamentals for a stock, technicals for an index). */
  tab?: StockTab;
}

export const STOCK_TABS = ["fundamentals", "technicals", "shareholding", "fno", "results", "announcements"] as const;
export type StockTab = (typeof STOCK_TABS)[number];

export const pages: PageDef[] = [
  {
    path: "/app/stocks",
    title: "Stocks",
    component: lazyRouteComponent(() => import("./StocksHome"), "StocksHome"),
    nav: { label: "Stocks", icon: CandlestickChart, group: "Research", order: 10 },
  },
  {
    path: "/app/stocks/$symbol",
    title: "Stock",
    component: lazyRouteComponent(() => import("./StockPage"), "StockPage"),
    validateSearch: (s): StockSearchParams => ({
      ...(typeof s.period === "string" && (PERIODS as readonly string[]).includes(s.period)
        ? { period: s.period as Period }
        : {}),
      ...(typeof s.iv === "string" && (INTERVALS as readonly string[]).includes(s.iv) ? { iv: s.iv as Interval } : {}),
      ...(typeof s.tab === "string" && (STOCK_TABS as readonly string[]).includes(s.tab) ? { tab: s.tab as StockTab } : {}),
      ...(typeof s.ov === "string" && /^[a-z0-9,]{0,40}$/.test(s.ov) ? { ov: s.ov } : {}),
    }),
  },
];
